import { render, staticRenderFns } from "./view-analyse-seller.vue?vue&type=template&id=33f2d488&scoped=true"
import script from "./view-analyse-seller.vue?vue&type=script&lang=js"
export * from "./view-analyse-seller.vue?vue&type=script&lang=js"
import style0 from "./view-analyse-seller.vue?vue&type=style&index=0&id=33f2d488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2d488",
  null
  
)

export default component.exports